<form [formGroup]="resourceForm" (ngSubmit)="onSubmit()" class="p-4 grid gap-4 md:grid-cols-2 bg-white rounded-lg py-3 mb-6 px-3" novalidate>

  <!-- Company Name and Address -->
   <div>
    <mat-label>Company Name and Address</mat-label>

     <mat-form-field  appearance="outline">
    <textarea matInput formControlName="companyName" rows="1"></textarea>
    <mat-error *ngIf="resourceForm.get('companyName')?.hasError('required')">
      Company Name is required
    </mat-error>
  </mat-form-field>
   </div>
 

  <!-- Domain -->
   <div>
    <mat-label>Domain</mat-label>

    <mat-form-field  appearance="outline">
    <mat-select formControlName="domain">
      <mat-option value="Commercial">Commercial</mat-option>
      <mat-option value="Education">Education</mat-option>
      <mat-option value="Electric">Electric</mat-option>
      <mat-option value="Gas">Gas</mat-option>
      <mat-option value="Residential">Residential</mat-option>
      <mat-option value="Road">Road</mat-option>
      <mat-option value="Water">Water</mat-option>
      <mat-option value="Telecom">Telecom</mat-option> </mat-select>
    <mat-error *ngIf="resourceForm.get('domain')?.hasError('required')">
      Domain is required
    </mat-error>
  </mat-form-field>
   </div>
  

  <!-- Key Contact -->
   <div>
    <mat-label>Key Contact</mat-label>

  <mat-form-field  appearance="outline">
    <input matInput formControlName="keyContact" />
    <mat-error *ngIf="resourceForm.get('keyContact')?.hasError('required')">
      Key contact is required
    </mat-error>
  </mat-form-field>
   </div>


  <!-- First Name -->
   <div>
    <mat-label>First Name</mat-label>

     <mat-form-field  appearance="outline">
    <input matInput formControlName="firstName" />
    <mat-error *ngIf="resourceForm.get('firstName')?.hasError('required')">
      First Name is required
    </mat-error>
  </mat-form-field>
   </div>
 

  <!-- Last Name -->
   <div>
    <mat-label>Last Name</mat-label>

      <mat-form-field  appearance="outline">
    <input matInput formControlName="lastName" />
    <mat-error *ngIf="resourceForm.get('lastName')?.hasError('required')">
      Last Name is required
    </mat-error>
  </mat-form-field>
   </div>


  <!-- Address -->
   <div>
    <mat-label>Address</mat-label>

 <mat-form-field  appearance="outline">
    <textarea matInput formControlName="address" rows="2"></textarea>
    <mat-error *ngIf="resourceForm.get('address')?.hasError('required')">
      Address is required
    </mat-error>
  </mat-form-field>
   </div>
 

  <!-- Mobile Number -->
   <div>
    <mat-label>Mobile Number</mat-label>

  <mat-form-field  appearance="outline">
    <input matInput formControlName="mobileNumber" />
    <mat-error *ngIf="resourceForm.get('mobileNumber')?.hasError('required')">
      Mobile number is required
    </mat-error>
    <mat-error *ngIf="resourceForm.get('mobileNumber')?.hasError('pattern')">
      Invalid mobile number
    </mat-error>
  </mat-form-field>
   </div>


  <!-- Email -->
   <div>
    <mat-label>Email</mat-label>

  <mat-form-field  appearance="outline">
    <input matInput formControlName="email" />
    <mat-error *ngIf="resourceForm.get('email')?.hasError('required')">
      Email is required
    </mat-error>
    <mat-error *ngIf="resourceForm.get('email')?.hasError('email')">
      Invalid email format
    </mat-error>
  </mat-form-field>
   </div>


  <!-- Employee Number -->
   <div>
    <mat-label>Employee Number</mat-label>

  <mat-form-field  appearance="outline">
    <input matInput formControlName="employeeNumber" />
    <mat-error *ngIf="resourceForm.get('employeeNumber')?.hasError('required')">
      Employee Number is required
    </mat-error>
  </mat-form-field>
   </div>


  <!-- Designation -->
   <div>
    <mat-label>Designation</mat-label>

 <mat-form-field  appearance="outline">
    <input matInput formControlName="designation" />
  </mat-form-field>
   </div>
 

  <!-- Role -->
   <div>
    <mat-label>Role in Software</mat-label>

 <mat-form-field  appearance="outline">
    <input matInput formControlName="role" />
  </mat-form-field>
   </div>
 

  <!-- Project Reference -->
   <div>
    <mat-label>Project Reference</mat-label>

 <mat-form-field  appearance="outline">
    <input matInput formControlName="projectReference" />
  </mat-form-field>
   </div>
 

  <!-- Client -->
   <div>
    <mat-label>Client</mat-label>

  <mat-form-field  appearance="outline">
    <input matInput formControlName="client" />
  </mat-form-field>
   </div>


  <!-- Project Start Date -->
   <div>
    <mat-label>Project Start Date</mat-label>

<mat-form-field  appearance="outline">
     <input matInput [matDatepicker]="startPicker" formControlName="projectStartDate">
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
    <mat-error *ngIf="resourceForm.get('projectStartDate')?.hasError('required')">
      Start date is required
    </mat-error>
  </mat-form-field>
   </div>
  

  <!-- Project End Date -->
   <div>
    <mat-label>Project End Date</mat-label>

 <mat-form-field  appearance="outline">
     <input matInput [matDatepicker]="endPicker" formControlName="projectEndDate">
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
    <mat-error *ngIf="resourceForm.get('projectEndDate')?.hasError('required')">
      End date is required
    </mat-error>
  </mat-form-field>
   </div>
 

  <!-- Form Actions -->
  <div class="md:col-span-2 flex justify-end gap-4 pt-4">
    <button mat-raised-button type="submit" color="primary">Submit</button>
  </div>
</form>

